import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { StepItem } from 'src/app/models/common/step-item';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { BaseService } from 'src/app/system-common/services/base.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Location } from '@angular/common';
import { AgentService } from 'src/app/agent/services/agent.service';

@Component({
  selector: 'sym-searches-test-api-step-form',
  templateUrl: './searches-test-api-step-form.component.html',
  styleUrls: ['./searches-test-api-step-form.component.scss'],
})
export class SearchesTestApiStepFormComponent
  extends BaseStepFormComponent<AgentService>
  implements OnInit, OnChanges
{
  options = [];
  public apiResponseData = null;
  public responseUpdated = false;
  public apiRequestData = { value: null };
  public scrollPosition = 0;
  public displayPopupApiResponse: boolean;
  public successResponse: any;
  @Input() restApiDataInfo: any;
  public createQuotationCallCounter = 0; //to solve guid duplication issue,create new guid if counter gretter than 1.

  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    public offlineService: OfflineService,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['restApiDataInfo'] && changes['restApiDataInfo'].currentValue) {
      setTimeout(() => {
        this.headerService.pageHeader = this.getPageHeader();
        if (this.restApiDataInfo.screenReqdFl == 'NO') this.restApiCall(this.restApiDataInfo.apiName);
        this.displayPopupApiResponse = false;
      }, 10);
    }
  }

  getStepList(): StepItem[] {
    let stepList: StepItem[] = [
      new StepItem(
        0,
        'step_testApiDetails',
        [
          {
            id: 'tab_basic',
            modelList: [
              'Entity',
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
            ],
          },
        ],
        ['but_Request']
      ),
    ];

    return stepList;
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search : Test Api';
    if (this.restApiDataInfo != undefined) {
      header.title = 'Search : ' + this.restApiDataInfo.apiDesc + ' API';
      header.additionalInfo = '( ' + this.restApiDataInfo.apiInfoDetails + ' )';
    }
    if (
      this.service.responseIO != undefined &&
      this.service.responseIO.data['BasePlan'] != undefined &&
      ((this.service.responseIO.data['BasePlan'].productSeq != undefined &&
        this.service.responseIO.data['BasePlan'].productSeq != null) ||
        (this.service.responseIO.data['BasePlan'].productId != undefined &&
          this.service.responseIO.data['BasePlan'].productId != null))
    ) {
      let productDesc = this.service.responseIO.data['BasePlan'].productLongName;
      header.title = header.title + ' for ' + productDesc;
    }

    return header;
  }

  protected postInit() {
    super.postInit();
    this.service.responseIO['isMetadataHelpReqd'] = false;
  }

  protected postLoad() {
    super.postLoad();
    this.service.responseIO['isMetadataHelpReqd'] = false;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
    ];
  }

  async sendRequest(tempRequest) {
    let apiName = this.restApiDataInfo.apiName;
    if (tempRequest.value != undefined) {
      this.apiRequestData.value = tempRequest.value;
    }

    //in save policy api,copy response data into request data,so solve row was updated issue.
    if (apiName == 'saveQuotation') {
      let apiRequestData = JSON.parse(this.apiRequestData.value);
      let apiResponseData = JSON.parse(this.apiResponseData);
      apiRequestData.body.FormData.Models = apiResponseData.data;
      this.apiRequestData.value = JSON.stringify(apiRequestData, null, '\t');
    } else if (apiName == 'createQuotation') {
      //this.updateQuotationGuid(true);
    }
    this.apiResponseData = undefined;
    this.apiResponseData = await this.service.sendRequest(this.apiRequestData.value, this.scrollPosition);
    //in save policy api,copy response data into service response io,so solve row was updated issue.
    if (apiName == 'saveQuotation' || apiName == 'getQuotation') {
      this.service.responseIO = JSON.parse(this.apiResponseData);
      this.service.responseIO.isMetadataHelpReqd = true;
    }
  }

  but_Request_click() {
    if (this.restApiDataInfo.apiName == undefined || this.restApiDataInfo.apiName == 'null') {
      this.warn('Please select a valid Api', undefined, true);
      return;
    }
    this.restApiCall(this.restApiDataInfo.apiName);
  }

  successApiResponse(successResponse: Object, trimRequestReq: boolean) {
    if (trimRequestReq) this.service.trimRequest();
    this.apiRequestData.value = JSON.stringify(this.service.httpReq, null, '\t');
    this.apiResponseData = JSON.stringify(successResponse, null, '\t');
    this.displayPopupApiResponse = true;
    this.openModal('apiRequest');
    if (this.restApiDataInfo != undefined && this.restApiDataInfo.screenReqdFl == 'NO') {
      this.openPopup('defaultPopup');
    }
  }

  errorApiResponse(error: any) {
    this.error(error.error);
    this.apiResponseData = undefined;
    this.displayPopupApiResponse = true;
    console.log('Error:', error);
    this.openModal('apiRequest');
  }

  restApiCall(selectedApiCd: string) {
    try {
      //eval('this.' + selectedApiCd + '()');
      this.Search(selectedApiCd);
    } catch (e) {
      this.error('Initialization error. Please select another API and try again.' + e);
    }
  }

  Search(searchName: string) {
    this.service.getSearchList(searchName, true, null).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }
}
